import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import "../thank-you/style.css";
import Navbar from '../../components/Navbar';

const Withdrawn = () => {
  const [accessGranted, setAccessGranted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      const hasAccess = sessionStorage.getItem("withdrawn");

      if (hasAccess) {
        setAccessGranted(true);
      } else {
        navigate("/");
      }
    }, 100);
  }, [navigate]);

  if (!accessGranted) {
    return null;
  }

  return (
    <>
      <Navbar />
      <section className="ul-facilites">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="ul-facilites--list">
                <li>
                  <b className="global-subheading global-fw600">
                    Your Application Was Withdrawn
                  </b>
                  <p>Dear {sessionStorage.getItem("applicationName") ?? 'Applicant'},</p>
                  <p>
                    Your application to <strong>Sitare University</strong> was withdrawn. If you would like to request a change, please contact our admissions office at  <a href="mailto:university@sitare.org" style={{ textDecoration: 'none', color: '#007BFF' }}>
                      university@sitare.org
                    </a>
                    &nbsp;or message us on&nbsp;
                    <a href="https://wa.me/+917849910085" style={{ textDecoration: 'none', color: '#128c7e' }}>
                      WhatsApp (+91 78499 10085)
                    </a>.
                  </p>
                  <p>
                    You can also find more information on our <a style={{ textDecoration: "none", color: '#007BFF' }} href="https://univ.sitare.org/admissions">admissions</a> page
                  </p>
                  <p>
                    <em>- Sitare University Admissions Team</em>
                  </p>
                </li>
                <div className="social-icons" style={{ textAlign: "center", marginTop: "20px" }}>
                  Smart applicants stay connected. Don't miss out. Follow us now! <br /><br />
                  <a href="https://www.linkedin.com/school/sitare-university/" target="_blank" rel="noopener noreferrer" style={{ margin: "0 10px" }}>
                    <img src="/assets/logo/linkedin.png" alt="LinkedIn" width="30" height="30" />
                  </a>
                  <a href="https://www.youtube.com/@SitareUniversity" target="_blank" rel="noopener noreferrer" style={{ margin: "0 10px" }}>
                    <img src="/assets/logo/youtube.png" alt="Youtube" width="30" height="30" />
                  </a>
                  <a href="https://www.instagram.com/sitareuniv" target="_blank" rel="noopener noreferrer" style={{ margin: "0 10px" }}>
                    <img src="/assets/logo/insta.jpeg" alt="Instagram" width="30" height="30" />
                  </a>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Withdrawn;
